import { z } from 'zod';

import {
  deriveSignedDocuments,
  isLegalKeyAgreed,
  type LegalDocumentGroup,
} from '@/modules/legalDocuments';
import { formatBirthdayForData } from '@/modules/localization';
import { OnboardingDataDraft } from '@/modules/rulesEngine';

import { LEGAL_KEY } from '../constants';
import { accountSchema } from '../schema/accountSchema';

type FormValues = z.infer<typeof accountSchema>;

// Derives draft state from form values. `legalGroups` is required to translate
// the form's `agreements` record (anchor-uuid → boolean) into the persistent
// `signedDocuments` array and the legacy `terms` / `consent` booleans that
// the customerProfile schema still requires.
export const mapFormValuesToDraft = (
  values: FormValues,
  legalGroups: LegalDocumentGroup[]
): Partial<OnboardingDataDraft> => {
  return {
    firstName: values.firstName ?? '',
    lastName: values.lastName ?? '',
    email: values.email ?? '',
    phone: values.phone ?? '',
    birthday: values.birthday ?? '',
    dateOfBirth: formatBirthdayForData(values.birthday ?? ''),
    terms: isLegalKeyAgreed(values.agreements, legalGroups, LEGAL_KEY.TERMS),
    consent: isLegalKeyAgreed(values.agreements, legalGroups, LEGAL_KEY.CONSENT),
    sms: values?.sms === true,
    signedDocuments: deriveSignedDocuments(values.agreements, legalGroups),
  };
};
